// extracted by mini-css-extract-plugin
export var bottomText = "footer-module--bottomText--70eaa";
export var footer = "footer-module--footer--dbec9";
export var footerWrap = "footer-module--footer-wrap--e6000";
export var topText = "footer-module--topText--25f95";
export var whiteText = "footer-module--whiteText--69dff";